// extracted by mini-css-extract-plugin
export default {"mCard":"eE-z","image":"fE-z","imageNoBackground":"gE-z","imageHasCategory":"hE-z","fullWidth":"iE-z"};